/**
 *
 * @module playbackEventListener
 *
 */

import Check from 'check-types';
import Exception from './../services/exception/entry';
import PlaybackMetricsProvider from './playbackMetricsProvider';

const InvalidArgumentException = Exception.InvalidArgumentException;

const {
    nonEmptyString,
    instanceStrict
} = Check.assert;

/**
 *
 * @class PlaybackEventListener
 * @since 2.0.0
 *
 */
export default class PlaybackEventListener {

    /**
     *
     * @access public
     * @param {PlaybackMetricsProvider} playbackMetricsProvider
     * @returns {Promise<Void>}
     *
     */
    onMediaChanged(playbackMetricsProvider) {

        const errorMessage = {
            method: 'PlaybackEventListener.onMediaChanged(playbackMetricsProvider)',
            get playbackMetricsProvider() {
                return `${this.method} needs PlaybackMetricsProvider instance`;
            }
        };

        instanceStrict(playbackMetricsProvider, PlaybackMetricsProvider, errorMessage.playbackMetricsProvider, InvalidArgumentException); // eslint-disable-line

        return new Promise((resolve) => {
            return resolve(new Error(`${errorMessage.method} - not-implemented`));
        });

    }

    /**
     *
     * @access public
     * @param {PlaybackMetricsProvider} playbackMetricsProvider
     * @returns {Promise<Void>}
     *
     */
    onPlay(playbackMetricsProvider) {

        const errorMessage = {
            method: 'PlaybackEventListener.onPlay(playbackMetricsProvider)',
            get playbackMetricsProvider() {
                return `${this.method} needs PlaybackMetricsProvider instance`;
            }
        };

        instanceStrict(playbackMetricsProvider, PlaybackMetricsProvider, errorMessage.playbackMetricsProvider, InvalidArgumentException); // eslint-disable-line

        return new Promise((resolve) => {
            return resolve(new Error(`${errorMessage.method} - not-implemented`));
        });

    }

    /**
     *
     * @access public
     * @param {PlaybackMetricsProvider} playbackMetricsProvider
     * @returns {Promise<Void>}
     *
     */
    onPause(playbackMetricsProvider) {

        const errorMessage = {
            method: 'PlaybackEventListener.onPause(playbackMetricsProvider)',
            get playbackMetricsProvider() {
                return `${this.method} needs PlaybackMetricsProvider instance`;
            }
        };

        instanceStrict(playbackMetricsProvider, PlaybackMetricsProvider, errorMessage.playbackMetricsProvider, InvalidArgumentException); // eslint-disable-line

        return new Promise((resolve) => {
            return resolve(new Error(`${errorMessage.method} - not-implemented`));
        });

    }

    /**
     *
     * @access public
     * @param {PlaybackMetricsProvider} playbackMetricsProvider
     * @param {String} message
     * @returns {Promise<Void>}
     *
     */
    onError(playbackMetricsProvider, message) {

        const errorMessage = {
            method: 'PlaybackTelemetryDispatcher.onError(playbackMetricsProvider, message)',
            get playbackMetricsProvider() {
                return `${this.method} needs PlaybackMetricsProvider instance`;
            },
            get message() {
                return `${this.method} message should be a String with length`;
            }
        };

        instanceStrict(playbackMetricsProvider, PlaybackMetricsProvider, errorMessage.playbackMetricsProvider, InvalidArgumentException); // eslint-disable-line

        if (Check.assigned(message)) {
            nonEmptyString(message, errorMessage.message, InvalidArgumentException);
        }

        return new Promise((resolve) => {
            return resolve(new Error(`${errorMessage.method} - not-implemented`));
        });

    }

    /**
     *
     * @access public
     * @param {PlaybackMetricsProvider} playbackMetricsProvider
     * @returns {Promise<Void>}
     *
     */
    onPlayedToCompletion(playbackMetricsProvider) {

        const errorMessage = {
            method: 'PlaybackTelemetryDispatcher.onPlayedToCompletion(playbackMetricsProvider)',
            get playbackMetricsProvider() {
                return `${this.method} needs PlaybackMetricsProvider instance`;
            }
        };

        instanceStrict(playbackMetricsProvider, PlaybackMetricsProvider, errorMessage.playbackMetricsProvider, InvalidArgumentException); // eslint-disable-line

        return new Promise((resolve) => {
            return resolve(new Error(`${errorMessage.method} - not-implemented`));
        });

    }

}



// WEBPACK FOOTER //
// ./src/media/playbackEventListener.js